// extracted by mini-css-extract-plugin
module.exports = {"close":"close-icon-module--close--1bPS_"};